module.exports = __webpack_public_path__ + "img/THE-BLOC-03.cde80b94.jpg";